"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styling = require("../../toolkit/styling");

var _device = require("../../toolkit/device");

var FlexRow = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _ref$alignItems = _ref.alignItems,
      alignItems = _ref$alignItems === void 0 ? "center" : _ref$alignItems,
      className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      justifyContent = _ref.justifyContent,
      divProps = (0, _objectWithoutProperties2["default"])(_ref, ["alignItems", "className", "style", "children", "justifyContent"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _styling.css)(className, style, {
      display: "flex",
      flexDirection: "row",
      alignItems: alignItems,
      justifyContent: justifyContent
    })
  }, divProps, {
    ref: ref
  }), children);
});

FlexRow.propDoc = {
  alignItems: {
    required: false,
    type: "CSSProperties[\"alignItems\"]",
    defaultValue: "center",
    description: "Indicates if the content should be alignItems vertically"
  },
  justifyContent: {
    required: false,
    type: "CSSProperties[\"justifyContent\"]",
    description: "Value to provide to the \"justifyContent\" CSS property."
  }
};
FlexRow.demoProps = {
  alignItems: "center"
};

var FlexColumn = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var alignItems = _ref2.alignItems,
      className = _ref2.className,
      style = _ref2.style,
      justifyContent = _ref2.justifyContent,
      children = _ref2.children,
      divProps = (0, _objectWithoutProperties2["default"])(_ref2, ["alignItems", "className", "style", "justifyContent", "children"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _styling.css)(className, style, {
      display: "flex",
      flexDirection: "column",
      alignItems: alignItems,
      justifyContent: justifyContent
    })
  }, divProps, {
    ref: ref
  }), children);
});

FlexColumn.propDoc = {
  alignItems: {
    required: false,
    type: "CSSProperties[\"alignItems\"]",
    description: "Value to provide to the \"alignItems\" CSS property."
  },
  justifyContent: {
    required: false,
    type: "CSSProperties[\"justifyContent\"]",
    description: "Value to provide to the \"justifyContent\" CSS property."
  }
};
FlexColumn.demoProps = {};

var GridRow = /*#__PURE__*/_react["default"].forwardRef(function (_ref3, ref) {
  var gap = _ref3.gap,
      style = _ref3.style,
      children = _ref3.children,
      className = _ref3.className,
      alignItems = _ref3.alignItems,
      templateColumns = _ref3.templateColumns,
      _ref3$smallScreenTemp = _ref3.smallScreenTemplateColumns,
      smallScreenTemplateColumns = _ref3$smallScreenTemp === void 0 ? "1fr" : _ref3$smallScreenTemp,
      divProps = (0, _objectWithoutProperties2["default"])(_ref3, ["gap", "style", "children", "className", "alignItems", "templateColumns", "smallScreenTemplateColumns"]);
  var isSmallScreen = (0, _device.useIsSmallScreen)();
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _styling.css)(className, style, {
      display: "grid",
      gridGap: gap,
      alignItems: alignItems,
      gridTemplateColumns: isSmallScreen ? smallScreenTemplateColumns : templateColumns
    })
  }, divProps, {
    ref: ref
  }), children);
});

GridRow.propDoc = {
  gap: {
    required: false,
    type: "CSSProperties[\"gridGap\"]",
    description: "Value to provide to the \"gridGap\" CSS property."
  },
  templateColumns: {
    required: false,
    type: "CSSProperties[\"gridTemplateColumns\"]",
    description: "Value to provide to the \"gridTemplateColumns\" CSS property."
  },
  alignItems: {
    required: false,
    type: "CSSProperties[\"alignItems\"]",
    description: "Indicates if the content should be alignItems vertically"
  },
  smallScreenTemplateColumns: {
    required: false,
    type: "CSSProperties[\"gridTemplateColumns\"]",
    description: "Value to provide to the \"gridTemplateColumns\" CSS property " + "when the screen space is small ."
  }
};
GridRow.demoProps = {
  gap: 10,
  templateColumns: "1fr 1fr"
};
var _default = {
  FlexRow: FlexRow,
  GridRow: GridRow,
  FlexColumn: FlexColumn
};
exports["default"] = _default;